import React, { useState } from 'react'; // importing FunctionComponent
import styled from 'styled-components';

import ICONS from '../../assets/icons';

import StyledList, {MainElementComponent as MainElements, ListElementComponent as ListElement} from '../styledList';
import InputText from '../inputText';
import useTextCorrection from '../../hooks/useTextCorrection';

// A touch more breathing room between the search box and the list below it,
// scoped to BuildingList's own wrapper rather than StyledList itself (shared by
// ActionTypeList and ScheduleSelectFilter, which don't sit under a search box).
const SearchCtn = styled.div`
  margin-bottom: 5px;
`;

const BuildingList: React.FC<any> = ({item, change, filter}): React.ReactElement => {
  const [buildingSearch, setBuildingSearch] = useState('');
  const { titleCase } = useTextCorrection();

  const items = Object.keys(item).filter((element) => {
    if (item[element].Description == undefined) return false;
    return item[element].Description.toLowerCase().indexOf(buildingSearch.toLowerCase()) >= 0;
  });

  const handleSearchChange = (event: any) => {
    setBuildingSearch(event.target.value);
  };

  return (
    <>
      <SearchCtn>
        <InputText
          text=""
          placeholder="Search buildings"
          name="buildingSearch"
          value={buildingSearch}
          missing={false}
          onChange={handleSearchChange}
        />
      </SearchCtn>
      <StyledList>
        {items.length !=0 &&
        items.map((element) => {
          return (
            <ListElement onClick={() => {
              change(element);
            }} value={element}>
              <MainElements data={filter} value={element}>
                <p value={item}>{titleCase(item[element].Description)}</p>
                <ICONS.check />
              </MainElements>
            </ListElement>
          );
        })}
      </StyledList>
    </>
  );
};

export default BuildingList;
